import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { displayFormattedDate, formatCurrency, isEmpty } from '../../../generalFunctions';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 10, textAlign: "left", alignSelf: "flex-start", marginRight: 25
    }
});

const PartyBillGSTList = (props) => {
    const { startDate, endDate } = props.dates;
    let totalAmount = 0; let totalCGST = 0; let totalSGST = 0; let totalIGST = 0; let totalOtherCharges = 0; let totalCommission = 0; let totalRoundOff = 0; let totalBillAmount = 0;
    props.data?.forEach((element, index) => {
        element.invoiceDate = displayFormattedDate(element.invoiceDate);

        totalAmount = totalAmount + element.total;
        totalCommission = totalCommission + element.commissionInRs;
        totalOtherCharges = totalOtherCharges + !isEmpty(element.otherChargesInRs) ? Number(element.otherChargesInRs).toFixed(2) : 0;
        totalCGST = totalCGST + element.cgst;
        totalSGST = totalSGST + element.sgst;
        totalIGST = totalIGST + element.igst;
        totalRoundOff = totalRoundOff + element.roundOff;
        totalBillAmount = totalBillAmount + element.finalBillAmount;

        element.total = Number(element.total).toFixed(2);
        element.commissionInRs = Number(element.commissionInRs).toFixed(2);
        element.cgst = Number(element.cgst).toFixed(2);
        element.sgst = Number(element.sgst).toFixed(2);
        element.igst = Number(element.igst).toFixed(2);
        element.cgstRate = Number(element.cgstRate).toFixed(2);
        element.sgstRate = Number(element.sgstRate).toFixed(2);
        element.igstRate = Number(element.igstRate).toFixed(2);
        element.roundOff = Number(element.roundOff).toFixed(2);
        element.otherChargesInRs = !isEmpty(element.otherChargesInRs) ? Number(element.otherChargesInRs).toFixed(2) : 0.00;
        element.finalBillAmount = Number(element.finalBillAmount).toFixed(2);
    });

    props.data.push({
        total: Number(totalAmount).toFixed(2),
        commissionInRs: Number(totalCommission).toFixed(2),
        cgst: Number(totalCGST).toFixed(2),
        sgst: Number(totalSGST).toFixed(2),
        igst: Number(totalIGST).toFixed(2),
        roundOff: Number(totalRoundOff).toFixed(2),
        otherChargesInRs: Number(totalOtherCharges).toFixed(2),
        finalBillAmount: Number(totalBillAmount).toFixed(2),
    });

    const tableData = {
        columnName: ["Inv No", "Inv Dt", "Party Name", "GSTIN", "Total", "Comm %", "Comm Amt", "Other Amt", "CGST %", "CGST", "SGST %", "SGST", "IGST %", "IGST", "Round Amt", "Bill Amt"],
        column: ["id", "invoiceDate", "accountName", "gstNumber", "total", "commission", "commissionInRs", "otherChargesInRs", "cgstRate", "cgst", "sgstRate", "sgst", "igstRate", "igst", "roundOff", "finalBillAmount"],
        width: [5, 7, 15, 11, 7, 3, 5, 5, 5, 5, 5, 5, 5, 5, 5, 7],
        align: ["left", "left", "left", "left", "right", "right", "right", "right", "right", "right", "right", "right", "right", "right", "right", "right"],
        data: props.data
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold", marginRight: 5 }}>{`Party Bill Checklist for the period: ${displayFormattedDate(startDate)} To ${displayFormattedDate(endDate)}`}</Text>
            </View>
            <View style={{ innerHeight: "80%" }}>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, textAlign: "center", fontSize: 9, marginRight: 1,
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 9, alignSelf: "flex-start", marginRight: 25 }}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </View>
        </Page>
    );
}

export default PartyBillGSTList;